export default __webpack_public_path__ + "static/media/dmy1.05ba3d9c.png";